module.exports = __webpack_public_path__ + "static/media/cityDelivery.e2261f56.png";